import ExpressionStore from './schema/ExpressionStore';
import { createStore } from 'satcheljs';
import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    DiverseEmojisOptions,
} from 'owa-outlook-service-options';

let expressionStoreData: ExpressionStore = {
    expressionPickerViewState: null,
    selectedSkinTone: getOptionsForFeature<DiverseEmojisOptions>(
        OwsOptionsFeatureType.DiverseEmojis
    ).diverseEmojisSelectedSkinTone,
    useFlexPane: null,
};

export let getStore = createStore<ExpressionStore>('expression', expressionStoreData);

var expressionStore = getStore();
export default expressionStore;
